import React, { Component } from 'react';
import { Modal, Button } from 'antd';
import AssessmentSheet from '../../Component/AssessmentSheet';

const SHEETDETAIL_TITLE = [
    '第一阶段评估',
    '第二阶段评估',
    '新人独立承接项目评估',
];

class SheetDetail extends Component {
    state = {
        visible: false,
        record: {},
        type: '0',
    }

    show = (type, record) => {
        this.setState({
            type,
            record,
            visible: true,
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    render() {
        const { visible, type, record } = this.state;
        const { userTeacherId } = record;
        return (
            <Modal
                title={SHEETDETAIL_TITLE[type]}
                visible={visible}
                onCancel={this.hide}
                maskClosable={false}
                width="1000px"
                bodyStyle={{ maxHeight: 500 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <AssessmentSheet disabled={true} userTeacherId={userTeacherId} type={type} />
            </Modal>
        );
    }
}

export default SheetDetail;


// WEBPACK FOOTER //
// ./src/components/teachingManagement/management/components/SheetDetail.js